<div class="hidewhenloading" #hidewhenloading>


    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <div class="card-header text-center">
                    <h4 class="display-5">School Plan</h4>
                </div>
                <div class="card-body plantiles" *ngIf="schoolplan">
                    <!-- <div class="text-center"><b>Current Plan: </b>{{schoolplan.name}}</div>
                    <div class="text-center"><b>Expiry Date: </b>{{schoolplan.currentAccountExpiryDateString}}</div> -->
                    <div class="row">
                        <div class="col-md-4"><b>Current Plan: </b></div>
                        <div class="col-md-8">{{schoolplan.name}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><b>Expiry Date:</b> </div>
                        <div class="col-md-8">{{schoolplan.currentAccountExpiryDateString}}</div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn w-100 planSlt"
                        routerLink="/account/schoolplan">{{schoolplan?"Change":"Select"}} Plan</button>
                </div>
            </div>
        </div>
        <!-- <div class="col-md-4">
            <div class="card">   
                <div class="card-header text-center">
                    <h4 class="display-5">V-Circle Plan</h4>                    
                </div>      
                <div class="card-body plantiles"  *ngIf="vcircleplan">
                    <div class="row"><div class="col-md-4"><b>Current Plan: </b></div><div class="col-md-8">{{vcircleplan.name}}</div></div>
                    <div class="row"><div class="col-md-4"><b>Expiry Date:</b> </div><div class="col-md-8">{{vcircleplan.currentAccountExpiryDateString}}</div></div>
                </div>
                <div class="card-body plantiles"  *ngIf="!vcircleplan">
                    <h2>No Running Subscription</h2>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn w-100 planSlt" (click)="vcircleclick()">{{vcircleplan?"Change":"Select"}} Plan</button>
                </div>
            </div>
        </div>                -->
        <div class="col-md-6">
            <div class="card">
                <div class="card-header text-center">
                    <h4 class="display-5">Account Details</h4>

                </div>
                <div class="card-body plantiles" *ngIf="school && school.accountName">
                    <div class="row">
                        <div class="col-md-4"><b>Account Name: </b></div>
                        <div class="col-md-8">{{school.accountName}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><b>Account Number:</b> </div>
                        <div class="col-md-8">{{school.accountNumber}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-4"><b>Bank: </b> </div>
                        <div class="col-md-8">{{school.bank}}</div>
                    </div>

                </div>
                <div class="card-body plantiles" *ngIf="!school || !school.accountName">
                    <h2>Account Details Not Set</h2>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn w-100 planSlt" routerLink="/account/accountdetails">{{school?
                        "Change":"Create"}} Account Details</button>
                </div>
            </div>
        </div>
    </div>
</div>